module.exports = __webpack_public_path__ + "static/media/llamadaActivo.2b16cd3f.svg";